// xlsxUtils.js
import * as XLSX from 'xlsx';

export const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }
  return buf;
};

export const handleExcelDownload = (jsonData, filename) => {
  // console.log(filename)
  // Convert JSON data to a worksheet
  const worksheet = XLSX.utils.json_to_sheet(jsonData);

  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, filename);

  // Generate a binary string representation of the workbook
  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

  // Create a Blob from the binary string
  const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });

  // Create a link element and trigger a download with the specified filename
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};
